import { ReactElement, MouseEvent, useRef } from 'react';
import { Button, Heading, Input, Text, VStack } from '@chakra-ui/react';
import { APIBackend } from 'libs/e2api/APIBackend';
import { Client } from 'libs/e2api/Client';

/**
 * Component to test the /updateDesignByPrompt endpoint
 * Can update a design based on prompt - for now only works well with card
 * type templates (1 title + 1 paragraph) text
 *
 * TODO: Will be removed once frontend flow from E1 is complete
 */
interface PromptPageProps {
  jwtToken: string;
}

let be: APIBackend;
let client: Client;

export const PromptPage = ({ jwtToken }: PromptPageProps): ReactElement => {
  if (!be) {
    be = new APIBackend({ authToken: jwtToken });
    client = new Client(be);
  }

  const promptRef = useRef<HTMLInputElement | null>(null);
  const designIdRef = useRef<HTMLInputElement | null>(null);

  const onSubmit = async (e: MouseEvent<HTMLButtonElement>) => {
    const prompt = promptRef.current?.value;
    const designId = designIdRef.current?.value;

    if (!prompt || !designId) {
      alert('Please enter a prompt and design id');
      return;
    }

    try {
      const res = await client.updateDesignByPrompt(designId!, prompt!);
      if (res.status !== 'ok') {
        throw new Error('Error calling api');
      }

      alert('Design updated successfully');
    } catch (err) {
      console.error(err);
      alert('Error updating design by prompt');
    }
  };

  return (
    <VStack spacing={4}>
      <Heading>Test /updateDesignByPrompt endpoint</Heading>
      <Text>
        This page is used to test the /updateDesignByPrompt endpoint. The endpoint is used to update the design based on
        the prompt. For now, only works with card type templates (1 title + 1 paragraph) text.
      </Text>
      <Input ref={promptRef} placeholder='Enter prompt (i.e. "mothers day card")' />
      <Input ref={designIdRef} placeholder='Enter E2 design id' />
      <Button onClick={onSubmit}>Update Design</Button>
    </VStack>
  );
};
